import React from "react";
import NumberFormat from "../../../helpers/number-format";
import OverviewContainer, {
  Section,
  SectionRow,
} from "../../OverviewContainer/OverviewContainer";
import sections from "./sections.json";

var LED1 = sections[3].fields.electrical.options[0].variations[0]; // price=210 as of 28.10.2021.

const Overview = ({
  size,
  heaters,
  interiorexterior,
  accessories,
  totalPrice,
}) => {
  return (
    <OverviewContainer
      title={`${size?.label} Wooden Hot Tub`}
      titlePrice={`£${NumberFormat(size?.price)}`}
      totalPrice={totalPrice}
    >
      <Section>
        <SectionRow>
          <strong>Heaters</strong>
        </SectionRow>
        <SectionRow>
          <span>
            {heaters.heater?.label} {heaters.heater?.variant}
          </span>
        </SectionRow>
        {heaters.upgrades.map((upgrade, index) => (
            <SectionRow key={index}>
            <span>
              {upgrade.label} {upgrade.variant}
            </span>
            </SectionRow>
        ))}
      </Section>

      <Section>
        <SectionRow>
          <strong>Interior & Exterior</strong>
        </SectionRow>
        <SectionRow>
          <span>{interiorexterior.wood?.label}</span>
        </SectionRow>
        {interiorexterior.woodTreatment.map((item, index) => (
          <SectionRow key={index}>
            <span>{item.label}</span>
          </SectionRow>
        ))}
        {interiorexterior.liner.map((item, index) => (
          <SectionRow key={index}>
            <span>
              {item.label} {item.variant}
            </span>
          </SectionRow>
        ))}
        {interiorexterior.liner.length > 0 && (
          <SectionRow>
            <span>Liner colour - {interiorexterior.linerColor?.label}</span>
          </SectionRow>
        )}
        {interiorexterior.seating && (
          <SectionRow>
            <span>{interiorexterior.seating?.label}</span>
          </SectionRow>
        )}
        <SectionRow>
          <span>{interiorexterior.lidCover?.label} lid</span>
        </SectionRow>
      </Section>

      <Section>
        <SectionRow>
          <strong>Accessories</strong>
        </SectionRow>
        {accessories.flueDrain.map((item, index) => (
          <SectionRow key={index}>
            <span>{item.label}</span>
          </SectionRow>
        ))}
        {accessories.electrical.map((item, index) => (
          <SectionRow key={index}>
          <span>
            {/* {item.label} {item.variant} */}
            {interiorexterior.liner.length === 0 &&
            index === 0 &&
            item.id === 1 &&
            (item.variant === "3 LED Lights" ||
              item.variant === "2 LED Lights")
              ? `${item.label} 1 LED Light`
              : `${item.label} ${item.variant}`}
          </span>
          {/*  TODO: Remove after GetQuote is merged*/}
          {/*<span>*/}
          {/*  {" "}*/}
          {/*  {interiorexterior.liner.length === 0 &&*/}
          {/*  index === 0 &&*/}
          {/*  item.id === 1 &&*/}
          {/*  (item.variant === "3 LED Lights" ||*/}
          {/*    item.variant === "2 LED Lights")*/}
          {/*    ? `£${LED1.price}`*/}
          {/*    : `£${NumberFormat(item.price)}`}*/}
          {/*</span>*/}
        </SectionRow>
        ))}
        {accessories.wooden.map((item, index) => (
          <SectionRow key={index}>
            <span>
              {item.quantity && `${item.quantity} x `} {item.label}
            </span>
          </SectionRow>
        ))}
        {accessories.waterCare.map((item, index) => (
          <SectionRow key={index}>
            <span>
              {item.label} {item.variant}
            </span>
          </SectionRow>
        ))}
      </Section>
    </OverviewContainer>
  );
};

export default Overview;
